export default {
  unitsPerEm: 1000,
  glyphs: {
    0: { advanceWidth: 610 },
    1: { advanceWidth: 440 },
    2: { advanceWidth: 610 },
    3: { advanceWidth: 610 },
    4: { advanceWidth: 610 },
    5: { advanceWidth: 610 },
    6: { advanceWidth: 610 },
    7: { advanceWidth: 610 },
    8: { advanceWidth: 610 },
    9: { advanceWidth: 610 },
    " ": { advanceWidth: 210 },
    a: { advanceWidth: 560 },
    b: { advanceWidth: 572 },
    c: { advanceWidth: 511 },
    d: { advanceWidth: 571 },
    e: { advanceWidth: 529 },
    f: { advanceWidth: 321 },
    g: { advanceWidth: 595 },
    h: { advanceWidth: 566 },
    i: { advanceWidth: 249 },
    j: { advanceWidth: 263 },
    k: { advanceWidth: 509 },
    l: { advanceWidth: 240 },
    m: { advanceWidth: 888 },
    n: { advanceWidth: 571 },
    o: { advanceWidth: 548 },
    p: { advanceWidth: 580 },
    q: { advanceWidth: 579 },
    r: { advanceWidth: 350 },
    s: { advanceWidth: 489 },
    t: { advanceWidth: 347 },
    u: { advanceWidth: 564 },
    v: { advanceWidth: 461 },
    w: { advanceWidth: 739 },
    x: { advanceWidth: 450 },
    y: { advanceWidth: 464 },
    z: { advanceWidth: 453 },
    A: { advanceWidth: 638 },
    B: { advanceWidth: 691 },
    C: { advanceWidth: 710 },
    D: { advanceWidth: 720 },
    E: { advanceWidth: 675 },
    F: { advanceWidth: 605 },
    G: { advanceWidth: 760 },
    H: { advanceWidth: 717 },
    I: { advanceWidth: 261 },
    J: { advanceWidth: 496 },
    K: { advanceWidth: 644 },
    L: { advanceWidth: 578 },
    M: { advanceWidth: 863 },
    N: { advanceWidth: 730 },
    O: { advanceWidth: 768 },
    P: { advanceWidth: 646 },
    Q: { advanceWidth: 800 },
    R: { advanceWidth: 693 },
    S: { advanceWidth: 672 },
    T: { advanceWidth: 608 },
    U: { advanceWidth: 729 },
    V: { advanceWidth: 607 },
    W: { advanceWidth: 956 },
    X: { advanceWidth: 588 },
    Y: { advanceWidth: 600 },
    Z: { advanceWidth: 673 },
    "-": { advanceWidth: 343 },
    "—": { advanceWidth: 947 },
    "–": { advanceWidth: 536 },
    _: { advanceWidth: 481 },
    "(": { advanceWidth: 350 },
    ")": { advanceWidth: 350 },
    ",": { advanceWidth: 257 },
    ".": { advanceWidth: 274 },
    ":": { advanceWidth: 274 },
    ";": { advanceWidth: 287 },
    "!": { advanceWidth: 283 },
    í: { advanceWidth: 256 }
  }
};
